package br.com.texeratx.boardgametimeapp.ui.screens.dashboard

import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model.DashboardGameUI
import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model.DashboardPlayerUI
import br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model.LastMatchesUI

data class DashboardUiState(
    val isLoading: Boolean = false,
    val error: String? = null,

    val topPlayers: List<DashboardPlayerUI> = emptyList(),
    val topGames: List<DashboardGameUI> = emptyList(),
    val lastMatches: List<LastMatchesUI> = emptyList(),

    val currentMonthMatches: Int = 0,
    val currentMonthMinutes: Int = 0
)
